import { Input, type InputProps } from '@library/components/inputs';
import { blockInvalidNumberChar } from '@library/component-utils/input';
import { classNames } from '@library/utils';
import { forwardRef } from 'react';

export const NUMBER_INPUT_DEFAULT_CLASSES =
  'bg-soFresh-110 text-soClean-100 block w-full rounded-md border border-soFresh-140 py-1.5 placeholder:text-soClean-140 sm:text-sm sm:leading-6';

export const NumberInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className = NUMBER_INPUT_DEFAULT_CLASSES,
      id,
      labelClassName = 'text-xs rounded-md uppercase leading-6 text-soClean-100',
      labelName = '',
      onChange,
      onValueChange,
      ...rest
    }: InputProps,
    ref
  ) => {
    return (
      <Input
        id={id}
        className={classNames(
          className,
          'outline-hidden [-moz-appearance:_textfield] focus:ring-0 [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none'
        )}
        labelClassName={labelClassName}
        labelName={labelName}
        onKeyDown={blockInvalidNumberChar}
        onValueChange={onValueChange}
        onChange={onChange}
        onWheel={(e) => {
          e.currentTarget.blur();
        }}
        ref={ref}
        type="number"
        {...rest}
      />
    );
  }
);
